import GreenPolicy from './views/greenPolicy.c';
export default GreenPolicy;
